module.exports = {
  mat3: require('./mat3'),
  vec2: require('./vec2'),
  vec3: require('./vec3'),
  transform: require('./transform')
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/@antv/util/lib/matrix/index.js
// module id = 2
// module chunks = 0